'use strict';

/**
 * Минимальная поддерживаемая веб-доступом ширина экрана.
 * @global
 */
window.MIN_SUPPORTS_WINDOW_WIDTH = 1024;
/**
 * Минимальная поддерживаемая веб-доступом высота экрана.
 * @global
 */
window.MIN_SUPPORTS_WINDOW_HEIGHT = 768;

/**
 * Режим отображения кнопки.
 *
 * @readonly
 * @enum {boolean}
 * @type {{LARGE: boolean, SMALL: boolean}}
 * @since 5.0.0.4104
 * @example
 *
 * // Создать кнопку с режимом отображения "Только иконка".
 * WebAccess.current.toolBar.groups.ATTACHMENTS.createButton("myButton", BUTTON.SMALL);
 */
window.BUTTON = {
  /** Отобразить иконку и подпись для кнопки. */
  LARGE: false,
  /** Отобразить только иконку кнопки. */
  SMALL: true
};

/**
 * Метод отправки формы на веб-сервер.
 *
 * @readonly
 * @global
 * @enum {string} FORM_METHOD
 * @since 5.0.0.7100
 */
window.FORM_METHOD = {
  /** Отправка методом POST */
  POST: 'POST',
  /** Отправка методом GET */
  GET: 'GET'
};
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

/**
 * Тип отправляемых данных формы.
 *
 * @readonly
 * @global
 * @enum {string} ENCTYPE
 * @since 5.0.0.7100
 */
window.ENCTYPE = {
  /** Данные формы в виде бинарного кода */
  MULTIPART: 'multipart/form-data',
  /** Данные формы в текстовом виде */
  URLENCODED: 'application/x-www-form-urlencoded'
};
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//


/**
 * Тип справочника с последними и избранными объектами.
 *
 * @readonly
 * @global
 * @enum {string} LAST_REFERENCES
 * @since 5.0.0.7200
 */
window.LAST_REFERENCES = {
  /**  Выбор доступен из справочников «Пользователи», «Группы пользователей» и «Типовые маршруты» */
  ALL: '',
  /** Выбор доступен из справочника «Пользователи» */
  ONLY_USERS: "!SR!G",
  /** Выбор доступен из справочников «Пользователи» и «Группы пользователей» */
  USERS_AND_GROUPS: "!SR"
};
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

/**
 * Направление сортировки.
 *
 * @readonly
 * @global
 * @enum {number} DIRECTION
 * @since 5.6.0.1000
 */
window.DIRECTION = {
  /** По возрастанию */
  ASC: 1,
  /** Без сортировки   */
  NONE: 0,
  /** По убыванию */
  DESC: -1
};

/**
 * Тип закладки карточки объекта.
 *
 * @readonly
 * @global
 * @enum {number} TAB_TYPE
 * @type {{CARD: number, HISTORY: number, RIGHTS: number, VERSIONS: number, ROUTE_SCHEME: number, CUSTOM_WORK_STATE: number, TASK_CARD: number, JOB_CARD: number}}
 * @since 5.6.0.1000
 */
window.TAB_TYPE = {
  /** Закладка «Карточка» */
  CARD: 0,
  /** Закладка «История» */
  HISTORY: 1,
  /** Закладка «Состояние» */
  RIGHTS: 2,
  /** Закладка "Состояние" в карточках документов */
  VERSIONS: 3,
  /** Закладка «Схема маршрута» в карточках задач и заданий */
  ROUTE_SCHEME: 4,
  /** Закладка «Состояние» в карточках задач и заданий */
  CUSTOM_WORK_STATE: 5,
  /** Карточка задачи */
  TASK_CARD: 6,
  /** Карточка задания */
  JOB_CARD: 7
};

/**
 * Тип колонки.
 *
 * @readonly
 * @global
 * @enum {number} COLUMN_TYPE
 * @since 5.6.0.9000
 */
window.COLUMN_TYPE = {
  /** Дата */
  DATE: 0,
  /** Строка */
  STRING: 1,
  /** Число */
  INTEGER: 2
};

/**
 * Тип объекта системы DIRECTUM.
 *
 * @readonly
 * @global
 * @enum {number} OBJECT_TYPE
 * @since 5.0.0.7100
 */
window.OBJECT_TYPE = {
  /** Неизвестный тип */
  UNKNOWN: 10,
  /** Папка */
  FOLDER: 0,
  /** Документ */
  EDOCUMENT: 1,
  /** Задания */
  JOB: 3,
  /** Задачи */
  TASK: 2,
  /** Компоненты */
  COMPONENT_TOKEN: 4,
  /** Произвольный тип */
  ANY: 5,
  /** Справочники */
  REFERENCE: 6,
  /** Сценарии */
  SCRIPT: 7,
  /** Отчеты */
  REPORT: 8,
  /** Запись справочника */
  REFERENCE_RECORD: 9,
  /** Пользователь */
  USER: 11,
  /** Мастер действий */
  WIZARD: 12,
  /** Пользователь или группа */
  USER_OR_GROUP: 100,
  /** Поиск */
  SEARCH: 101,
  /** Диалог */
  DIALOG: 102
};

/**
 * Приоритет задачи.
 *
 * @const
 * @global
 * @enum {string} TASK_IMPORTANCE
 * @type {{LOW: string, NORMAL: string, HIGH: string}}
 */
window.TASK_IMPORTANCE = {
  /** Низкая важность */
  LOW: 0,
  /** Нормальная важность */
  NORMAL: 1,
  /** Высокая важность */
  HIGH: 2
};

/**
 * Тип состояния задачи и задания.
 *
 * @readonly
 * @global
 * @enum {string} WORK_STATE
 * @since 5.5.0.9092
 */
window.WORK_STATE = {
  /** Инициализация */
  INIT: 0,
  /** В работе */
  RUNNING: 1,
  /** Выполнено */
  DONE: 2,
  /** На контроле */
  CONTROLLED: 3,
  /** Прекращено */
  ABORTED: 4,
  /** Возобновлена */
  CONTINUED: 5
};

/**
 * Типы данных значений реквизитов.
 *
 * @readonly
 * @global
 * @enum {string} REQUISITE_TYPE
 * @since 5.2.0.1300
 */
window.REQUISITE_TYPE = {
  /** Пусто */
  EMPTY: 0,
  /** Дата */
  DATE: 1,
  /** Дробное число */
  FLOAT: 2,
  /** Признак */
  PICK: 3,
  /** Строка */
  STRING: 4,
  /** Справочник */
  REFERENCE: 5,
  /** Текст */
  TEXT: 6,
  /** Целое число */
  INTEGER: 7,
  /** Большое целое число */
  LARGE_INTEGER: 8,
  /** Документ */
  DOCUMENT: 9,
  /** Список объектов */
  OBJECT_LIST: 11
};

/**
 * @readonly
 * @global
 * @enum {string} ACTION_ENABLED_MODE
 * @since 5.5.0.2201
 */
window.ACTION_ENABLED_MODE = {
  /** Доступно. */
  ENABLED_ALWAYS: 0,
  /** Недоступно. */
  DISABLED_ALWAYS: 1,
  /** Доступно при просмотре. */
  ENABLED_ON_BROWSE: 2,
  /** Доступно при редактировании. */
  ENABLED_ON_EDIT: 3,
  /** Недоступно без данных. */
  DISABLED_ON_BROWSE_EMPTY: 4
};

/**
 * Условия доступности действий в ЗЗУ.
 *
 * @readonly
 * @global
 * @enum {number} JOB_ACTION_ENABLED_WHEN
 * @type {{IS_ENABLED_ON_ATTACHMENT_SELECTED: number, IS_ENABLED_ON_ABORTED: number, IS_ENABLED_ON_DONE: number, IS_ENABLED_ON_RUNNING: number}}
 * @since 5.6.0.1300
 */
window.JOB_ACTION_ENABLED_WHEN = {
  /** Действие доступно, если в области вложений выделен хотя бы один элемент */
  IS_ENABLED_ON_ATTACHMENT_SELECTED: 1 << 0,
  /** Действие доступно, если ЗЗУ прекращено */
  IS_ENABLED_ON_ABORTED: 1 << 1,
  /** Действие доступно, если ЗЗУ выполнено */
  IS_ENABLED_ON_DONE: 1 << 2,
  /** Действие доступно, если ЗЗУ в работе */
  IS_ENABLED_ON_RUNNING: 1 << 3
};

/**
 * @readonly
 * @global
 * @enum {number} CONTENTS_ACTION_ENABLED_MODE
 * @type {{ENABLED_IN_SELECTED_MODE: number, ENABLED_ONLY_FOR_SELECTED: number, ENABLED_WHEN_MULTISELECT: number}}
 * @since 5.6.0.2700
 */
window.CONTENTS_ACTION_ENABLED_MODE = {
  /** Доступно в режиме списка. */
  ENABLED_IN_SELECTED_MODE: 1 << 0,
  /** Доступно только для выделенных записей. */
  ENABLED_ONLY_FOR_SELECTED: 1 << 1,
  /** Доступно при множесетвенном выборе. */
  ENABLED_WHEN_MULTISELECT: 1 << 2
};

/**
 * Режим расположения.
 *
 * @readonly
 * @enum {number} ORIENTATION
 * @since 5.0.0.4200
 *
 * @example
 * //Установить горизонтальное расположение боковой панели.
 * WebAccess.current.sideBar.setOrientation(ORIENTATION.HORISONTAL);
 *
 * @example
 * //Установить последовательное горизонтальное расположение элементов на форме.
 * var form = WA.CMP.forms.FormBuilder('someForm');
 * form.setOrientation(ORIENTATION.VERTICAL);
 */
window.ORIENTATION = window.SIDEBAR_ORIENTATION = {
  /** Горизонтальное */
  HORIZONTAL: 0,
  /** Вертикальное */
  VERTICAL: 1
};

/**
 * Тип получаемой модели данных.
 *
 * @readonly
 * @enum {number} MODEL
 * @since 5.0.0.7300
 */
window.MODEL = {
  /** Полные данные */
  FULL: 0,
  /** Карточка */
  CARD: 1,
  /** Содержимое объекта */
  CONTENT: 2,
  /** Ссылка */
  LINK: 3
};

/**
 * Тип доступа к деловому процессу.
 *
 * @readonly
 * @enum {number} WORK_ACCESS_TYPE
 * @since 5.0.0.7300
 */
window.WORK_ACCESS_TYPE = {
  /** Всем */
  ALL: 0,
  /** Ручной */
  MANUAL: 2,
  /** Участникам */
  PARTICIPANTS: 1
};

/**
 * Тип задания.
 *
 * @readonly
 * @enum {number} JOB_KIND
 * @since 5.0.0.7300
 */
window.JOB_KIND = {
  /** Задание */
  JOB: 0,
  /** Уведомление */
  NOTICE: 1,
  /** Задание-контроль */
  CONTROL_JOB: 2
};

/**
 * Тип сообщения.
 *
 * @readonly
 * @enum {number} MESSAGE_TYPE
 * @since 5.0.0.7300
 *
 * TODO: MESSAGE_TYPE переименовать в INLINE_HINT_TYPE (более корректное название).
 */
window.MESSAGE_TYPE = {
  /** Предупреждение */
  WARNING: 0,
  /** Сообщение об ошибке */
  ERROR: 1,
  /** Информационное сообщение */
  INFO: 2,
};

/**
 * Приоритет встроенной подсказки.
 *
 * @readonly
 * @enum {number} INLINE_HINT_PRIORITY
 * @type {{PRIMARY: number, SECONDARY: number}}
 * @since 5.6.0.9050
 */
window.INLINE_HINT_PRIORITY = {
  /** Исключение */
  PRIMARY: 0,
  /** Подсказка */
  SECONDARY: 1,
};

/**
 * Тип содержимого папки.
 *
 * @readonly
 * @enum {number} FOLDER_CONTENT_TYPE
 * @since 5.0.0.7300
 */
window.FOLDER_CONTENT_TYPE = {
  /** Документы */
  EDOCUMENT: 1,
  /** Задания */
  JOB: 3,
  /** Задачи */
  TASK: 2,
  /** Вариант запуска */
  COMPONENT_TOKEN: 4,
  /** Произвольный тип */
  ANY: 5
};

/**
 * Тип папки.
 *
 * @readonly
 * @enum {number} FOLDER_TYPE
 * @since 5.0.0.7300
 */
window.SPEC_FOLDER_TYPE = window.FOLDER_TYPE = {
  /** Папка «Входящие» */
  INBOX: 0,
  /** Папка «Исходящие» */
  OUTBOX: 1,
  /** Папка «Избранное» */
  FAVORITES: 2,
  /** Папка «Общая папка» */
  COMMON_FOLDER: 3,
  /** Папка пользователя */
  USER_FOLDER: 4,
  /** Специальный объект «Ярлыки» */
  SHORTCUTS: 7,
  /** Папка поиска */
  SEARCH: 8
};

/**
 * Уровень журналирования
 *
 * @readonly
 * @since 5.1.0.1523
 * @enum {string} LOG_LEVEL
 * @global
 */
window.LOG_LEVEL = {
  /** Сообщение об ошибке */
  ERROR: 'E',
  /** Предупреждение */
  WARN: 'W',
  /** Информационное сообщение */
  INFO: 'I',
  /** Сообщение об отладке */
  DEBUG: 'D'
};

/**
 * Уровень сериализации
 *
 * @readonly
 * @since 5.2.0.1600
 * @enum {number} SERIALIZATION
 * @global
 */
window.SERIALIZATION = {
  /** Минимальная сериализация, по умолчанию */
  LITE: '1',
  /** Максимальное кол-во данных */
  FULL: '2'
};

/**
 * Названия стандартных действий диалога.
 *
 * @readonly
 * @since 5.2.0.1901
 * @enum {String} DIALOG_ACTION
 * @global
 */
window.DIALOG_ACTION = {
  /** ОК */
  OK: 'OkAction',
  /** Отмена */
  CANCEL: 'CancelAction'
};

/**
 * Режим открытия справочника в модальном окне.
 *
 * @readonly
 * @since 5.4.0.1013
 * @enum {number} REFERENCE_MODAL_MODE
 * @global
 */
window.REFERENCE_MODAL_MODE = {
  /** Просмотр */
  VIEW: 0,
  /** Единичный выбор */
  SINGLE: 1,
  /** Множественный выбор */
  MULTI: 2
};

/**
 * Тип переменной.
 *
 * @readonly
 * @since 5.5.0.1000
 * @enum {number} VARIANT_TYPE
 * @global
 */
window.VARIANT_TYPE = {
  /** Целое число */
  INTEGER: 0,
  /** Число с плавающей точкой */
  SINGLE: 1,
  /** Строка */
  STRING: 2,
  /** Логический тип */
  BOOLEAN: 3,
  /** Дата */
  DATE_TIME: 4,
  /** Задача */
  TASK: 5,
  /** Задание */
  JOB: 6,
  /** Папка */
  FOLDER: 7,
  /** Документ */
  DOCUMENT: 8,
  /** Запись справочника */
  REFERENCE_RECORD: 9,
  /** Пользователь */
  USER: 10,
  /** Группа пользователей */
  USER_GROUP: 11,
  /** Роль */
  USER_ROLE: 12,
  /** Коллекция целых чисел */
  INTEGER_COLLECTION: 13,
  /** Коллекция чисел с плавающей точкой */
  SINGLE_COLLECTION: 14,
  /** Коллекция строк */
  STRING_COLLECTION: 15,
  /** Коллекция логических типов */
  BOOLEAN_COLLECTION: 16,
  /** Коллекция дат */
  DATE_TIME_COLLECTION: 17,
  /** Коллекция задач */
  TASK_COLLECTION: 18,
  /** Коллекция заданий */
  JOB_COLLECTION: 19,
  /** Коллекция папок */
  FOLDER_COLLECTION: 20,
  /** Коллекция документов */
  DOCUMENT_COLLECTION: 21,
  /** Коллекция записей справочника */
  REFERENCE_RECORD_COLLECTION: 22,
  /** Коллекция пользователей */
  USER_COLLECTION: 23,
  /** Коллекция групп пользователей */
  USER_GROUP_COLLECTION: 24,
  /** Коллекция ролей */
  USER_ROLE_COLLECTION: 25
};

/**
 * Режим открытия документа в мастере действий.
 *
 * @readonly
 * @enum {number} WIZARD_DOCUMENT_STEP_SHOW_MODE
 * @since 5.4.1.1000
 */
window.WIZARD_DOCUMENT_STEP_SHOW_MODE = {
  /** Открывать содержимое документа  */
  BODY: 0,
  /** Открывать карточку документа */
  CARD: 1
};

/**
 * Операции, доступные для токена.
 *
 * @readonly
 * @enum {number} TOKEN_OPERATION
 * @since 5.4.2.2000
 */
window.TOKEN_OPERATION = {
  /** Токен для операции получения тела документа  */
  DOWNLOAD_DOCUMENT_BODY: 1,
  /** Токен для операции открытия карточки документа */
  UPLOAD_DOCUMENT_BODY: 2,
  /** Токен для операции обновления Агента */
  UPDATE_AGENT: 4,
  /** Токен для операции подписания документа */
  SIGN_DOCUMENT: 8,
  /** Токен для операции подписания задачи или задания */
  SIGN_TASK: 8,
  /** Токен для операции получения списка новых заданий */
  GET_NEW_JOB_LIST: 16,
  /** Токен для операции блокировки тела документа */
  LOCK_VERSION: 32,
  /** Токен для операции разблокировки тела документа */
  UNLOCK_VERSION: 64,
  /** Токен для операции получения зашифрованного сессионного ключа */
  GET_ENCRYPTION_KEY: 128,
  /** Токен для операции диагностики */
  DIAGNOSTICS: 1073741824
};

/**
 * Константы из бэкенда для explorer
 *
 * @readonly
 * @enum {number} EXPLORER
 * @since 5.6.0.9009
 */
window.EXPLORER = {
  /** Максимальное кол-во строк в списке объектов  */
  /** Должна быть равна NpoComputer.WebAccess.Constants.MAX_OBJECT_ROWS_COUNT */
  MAX_OBJECT_ROWS_COUNT: 23,
};

/**
 * События страницы.
 * Используются для генерации событий из React-компонент.
 *
 * @enum
 * @type {{TOOLBAR_BUTTONS_INIT_DONE: string, TOOLBAR_GROUPS_INIT_DONE: string, ON_BEFORE_TAB_CHANGE: string, TAB_ON_BEFORE_RENDER_NEW_MODEL: string, TAB_ON_AFTER_RENDER_NEW_MODEL: string}}
 */
window.PAGE_EVENTS = {
  /** Окончание инициализации кнопок панели действий */
  TOOLBAR_BUTTONS_INIT_DONE: 'toolbarButtonsInitDone',
  /** Окончание инициализации групп кнопок панели действий */
  TOOLBAR_GROUPS_INIT_DONE: 'toolbarGroupsInitDone',
  /** До переключения вкладки */
  ON_BEFORE_TAB_CHANGE: 'OnBeforeTabChange',
  /** До генерации страницы на основании новой модели */
  TAB_ON_BEFORE_RENDER_NEW_MODEL: 'tabOnBeforeRenderNewModel',
  /** После генерации страницы на основании новой модели */
  TAB_ON_AFTER_RENDER_NEW_MODEL: 'tabOnAfterRenderNewModel',
};

/**
 * Длина разметки, с которой начинает падать Firefox c ошибкой ns_error_illegal_value.
 *
 * @readonly
 * @since 5.6.0.9054
 */
window.MAIN_TAB_CONTENT_SAFE_LENGTH = 65536;

/**
 * Настройки отправки статистики
 *
 * @readonly
 * @enum {number} STATISTICS
 * @since 5.6.0.9054
 */
window.STATISTICS = Object.freeze({
  /** Мин. интервал обработки событий статистики, мс.
   * Из всех событий, поступивших в течение этого интервала, на отправку уйдёт только последнее. */
  DEBOUNCE_INTERVAL: 200,
  /** Мин. интервал отправки статистики, мс. */
  REQUEST_INTERVAL: 10 * 1000,
  /** Мин. количество событий в одном запросе к серверу.
   * Если стек уже собрался, но REQUEST_INTERVAL ещё не прошёл, стекаем события дальше. */
  STACK_SIZE: 10,
});

/**
 * Режимы отображения папки.
 *
 * @readonly
 * @enum {number} FOLDER_MODE
 * @since 5.6.0.9057
 */
window.FOLDER_MODE = Object.freeze({
  /** Не определен */
  NONE: 0,
  /** Обложка. */
  COVER: 1,
  /** Список. */
  LIST: 2,
  /** Грид. */
  GRID: 3,
});

/**
 * Константы, относящиеся к режиму грида объектов проводника.
 *
 * @readonly
 * @enum {string, number} FOLDER_GRID
 * @since 5.6.0.9057
 */
window.FOLDER_GRID = Object.freeze({
  /** Ключ объекта настроек ширин колонок грида в localStorage. */
  WIDTHS_STORAGE_KEY: 'folderGridWidths',
  /** Ключ сохранённого режима отображения папки. */
  FOLDER_MODE_KEY: '##m',
  /** URL-параметр для режима отображения папки. */
  FOLDER_MODE_URL_PARAM: 'fmode',
  /** Значение ширины колонки по умолчанию, px. */
  DEFAULT_COLUMN_WIDTH: 200,
  /** Минимальная ширина колонки, px. */
  MIN_COLUMN_WIDTH: 24,
  /** Максимальная ширина колонки, px. */
  MAX_COLUMN_WIDTH: 1024,
});

/**
 * Фильтры дерева состояний.
 *
 * @readonly
 * @enum {string, number} STATETREE_FILTER
 * @since 5.6.1.9000
 */
window.STATETREE_FILTER = Object.freeze({
  /** Все */
  ALL: 0,
  /** В работе */
  RUNNING: 1,
  /** Задачи */
  JOBS: 2,
  /** Просроченные */
  OUTDATED: 3,
  /** Непрочитанные */
  UNREAD: 4,
});
